export const contractHolder = {
  emulator: null,
  testnet: "0xb05b2abb42335e88",
  mainnet: "0x233eb012d34b0070"
}
